import { Link } from "react-router-dom";

import {
  FiArrowRight,
  RiHeartPulseFill,
  RiDossierFill,
  RiTimeFill,
  PiClockCountdownFill,
  PiCurrencyDollarSimpleFill,
  PiArrowBendDoubleUpRightBold,
} from "../../assets/icons/vander";

export const FeatureOne = () => {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-10">
          <div className="features-absolute bg-white shadow rounded overflow-hidden card-group">
            <div className="card border-0 bg-light p-4">
              <PiClockCountdownFill className="text-primary h2" />
              <h5 className="mt-1">Ahorro de tiempo</h5>
              <p className="text-muted mt-2">
                Optimiza el tiempo y la calidad de preparación de pacientes para
                procedimientos de bajo o medio riesgo.
              </p>
            </div>

            <div className="card border-0 p-4">
              <PiCurrencyDollarSimpleFill className="text-primary h2" />
              <h5 className="mt-1">Ahorro de dinero</h5>
              <p className="text-muted mt-2">
                Ahorra en consultas preanestésicas e incrementa el número de
                pacientes a intervenir quirúrgicamente por unidad de tiempo.
              </p>
            </div>

            <div className="card border-0 bg-light p-4">
              <PiArrowBendDoubleUpRightBold className="text-primary h2" />
              <h5 className="mt-1">Optimización del proceso</h5>
              <p className="text-muted mt-2">
                Ofrece mejor atención a tus pacientes con un flujo preanestésico
                dirigido por IA con menos tramitología, menos desplazamientos y
                decisiones dirigidas por datos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
